/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Továrna na zaznamenávače výjimek pro Console API.
 */
class ConsoleLoggerFactory {
  /**
   * Vytvoří instanci.
   * @param {Class.<ConsoleLogger>} ConsoleLogger
   * @param {Console} console
   * @param {ErrorLevelFactory} errorLevelFactory
   */
  constructor(ConsoleLogger, console, errorLevelFactory) {
    this.ConsoleLogger = ConsoleLogger;
    this.console = console;
    this.errorLevelFactory = errorLevelFactory;
  }

  /**
   * Vytvoří nový zaznamenávač výjimek.
   * @returns {ConsoleLogger}
   */
  create() {
    return new this.ConsoleLogger(this.console, this.errorLevelFactory);
  }
}

export default ConsoleLoggerFactory;
